<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()"><a-icon type="plus" />新增</a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete"><a-icon type="delete" />删除</a-button>
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false" :bordered="tableBordered">
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="(checked) => handleStatusChange(record, checked)" />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)"><a-icon type="edit" />修改</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)"><a-icon type="delete" />删除</a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOperationPrice, delOperationPrice, updateOperationPrice } from '@/api/cloudplant/operationPrice'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm'

export default {
  name: 'OperationPrice',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [], loading: false, selectedRowKeys: [], multiple: true, queryParam: { pageNum: 1, pageSize: 100 },
      columns: [
        { title: '操作类型', dataIndex: 'operationName', align: 'center' },
        { title: '次数', dataIndex: 'count', align: 'center', width: 80 },
        { title: '价格(元)', dataIndex: 'price', align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center', width: 80 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 100 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 150 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getList() { this.loading = true; pageOperationPrice(this.queryParam).then(response => { this.list = response.data.records; this.loading = false }) },
    onSelectChange(selectedRowKeys) { this.selectedRowKeys = selectedRowKeys; this.multiple = !selectedRowKeys.length },
    handleStatusChange(record, checked) { updateOperationPrice({ id: record.id, status: checked ? 1 : 0 }).then(() => { this.$message.success('修改成功'); this.getList() }) },
    handleDelete(row) {
      const that = this
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: '确认删除所选中数据?',
        onOk() {
          let data = []
          if (row.id) { data.push(row.id) } else { that.selectedRowKeys.forEach(id => data.push(id)) }
          return delOperationPrice(data).then(() => { that.onSelectChange([]); that.getList(); that.$message.success('删除成功', 3) })
        }
      })
    }
  }
}
</script>
